import { arrowLeft } from 'assets';
import { Modal } from 'components';
import { FC } from 'react';
import { GetDetailImageResponse, ImageAlbum } from 'types';
import { Skeleton } from 'antd';

import { dayjs } from 'libs';
import { HeaderStyled, DetailImageContentStyled } from 'pages/Home/Dtc/Albums/Modals/styles';

interface Props {
  data?: ImageAlbum | null;
  setVisibleModalImage: (close: boolean) => void;
  visible: boolean;
  images: ImageAlbum[];
  detailImage: GetDetailImageResponse | null;
  setLoadingOneImage: (loading: boolean) => void;
  loadingOneImage: boolean;
}

const DetailImageCm: FC<Props> = ({
  visible,
  setLoadingOneImage,
  loadingOneImage,
  setVisibleModalImage,
  detailImage,
}) => {
  const onCancelImage = () => {
    setLoadingOneImage(true);
    setVisibleModalImage(false);
  };
  return (
    <>
      <Modal
        title={
          <HeaderStyled onClick={onCancelImage}>
            <img src={arrowLeft} alt="arrowLeft" />
            <div>写真詳細</div>
          </HeaderStyled>
        }
        visible={visible}
        footer={false}
        width={960}
      >
        <DetailImageContentStyled>
          <div className="image">
            {loadingOneImage ? (
              <Skeleton.Button active style={{ width: 600, height: 450, maxWidth: '100%' }} />
            ) : (
              <img src={detailImage?.image_url} alt="img-modal" className="image image-graft" />
            )}
          </div>
          <div className="info">
            <div className="title">情報</div>
            <div className="info-item">工事コード：{detailImage?.building_code}</div>
            <div className="info-item">現場名：{detailImage?.site_name}</div>
            {/** 2024/01/30 Leading Win 写真機能対応 DXWEBTPG00101_写真詳細 start*/}
            {/** <div className="info-item">種別：{detailImage?.daikoji_name || 'その他'}</div>*/}
            {/** 2024/01/30 Leading Win 写真機能対応 DXWEBTPG00101_写真詳細 end*/}
            <div className="info-item">撮影者：{detailImage?.taken_user_name} </div>
            <div className="info-item">
              撮影日時：
              {detailImage?.taken_date
                ? dayjs(detailImage?.taken_date).format('YYYY/MM/DD HH:mm')
                : ''}
            </div>
            <div className="info-item">コメント：{detailImage?.comment}</div>
          </div>
        </DetailImageContentStyled>
      </Modal>
    </>
  );
};

export default DetailImageCm;
